//@ts-nocheck
import { useState } from "react";
import { IUseViewModelProps } from "./types";
function formatOptions(options = []) {
  if (Array.isArray(options)) {
    return options.map((item) => ({ label: item, value: item }));
  }
  return [];
}
function placeholder() {
  let placeholders = {
    lessonType: {
      label: "Lesson type",
      options: [
        {
          label: "Physical",
          description: "Home lessons",
          value: "physical",
        },
        {
          label: "Online",
          description: "Virtual lessons",
          value: "online",
        },
      ],
    },
    country: {
      label: "Country",
      placeholder: "Select country",
    },
    state: {
      label: "State",
      placeholder: "Select state",
    },
    region: {
      label: "Region",
      placeholder: "Select region",
    },
  };

  return {
    country: placeholders.country,
    state: placeholders.state,
    region: placeholders.region,
  };
}

export interface IUseLocationVMProps {
  lessonType?: string[] | "physical" | "online";
  country?: string;
  country_code?: string;
  state?: string;
  region?: string;
  vicinity?: string;
  address?: string;
  countries?: Array<{
    states: Array<{
      name: string;
      code: string;
    }>;
    name: string;
    code2: string;
  }>;
  regions?: Array<{
    state: string;
    vicinity: string;
    factor: number;
  }>;
  countriesSupported?: any[];
  supportedCountries?: string[];
  latitude?: number;
  longitude?: number;
  customerType?: "parent" | "child";
  phone?: string;
  neighboringRegion?: string;
}

export const useLocationVM = (
  props: IUseLocationVMProps,
  adapter: IUseViewModelProps["adapter"]
) => {
  const [data, setData] = useState<IUseLocationVMProps>(props);
  const [loading, setLoading] = useState(false);

  function inSupportedCountry(country: string) {
    return data.countriesSupported?.includes(country);
  }
  function getStates(country: string) {
    if (country) {
      let stateOptions = data.countries?.find((item) => item.name === country);
      if (stateOptions) {
        stateOptions = stateOptions.states.map((item) => item.name);
      }
      return stateOptions || [];
    }
    return [];
  }
  function getRegions(state: string) {
    if (state) {
      let regionOptions = data.regions
        ?.filter((item) => item.state === state)
        .map((item) => item.vicinity);
      return regionOptions;
    }
    return [];
  }
  function getCountryCode(country: string) {
    let countryObj = data.countries?.find((item) => item.name === country);
    return countryObj?.code2;
  }
  function getFactor() {
    let filteredRegion = data.regions?.find(
      (item) => item.state === data.state && item.vicinity === data.region
    );

    let factor = filteredRegion?.factor ? filteredRegion.factor : 1;
    return factor;
  }
  // actions
  function handleChange(key: string, selectedOption: any) {
    const self = { ...data };
    if (key === "lessonType") {
      self.lessonType = selectedOption;
    }
    if (key === "state") {
      self.state = selectedOption;
      self.region = "";
      self.region = "";
      self.vicinity = "";
      self.address = "";
    }

    if (key === "region") {
      if (selectedOption) {
        self.region = selectedOption;
        self.vicinity = "";
        self.address = "";
        // getNeighboringArea();
      } else {
        self.region = "";
      }
    }
    if (key === "country") {
      self.country = selectedOption;
      self.state = "";
      self.region = "";
      self.vicinity = "";
      self.address = "";
      if (self.country && !self.supportedCountries?.includes(self.country)) {
        self.lessonType = ["online"];
      }
    }
    setData(self);
    return {
      country: self.country,
      state: self.state,
      region: self.region,
      address: self.address,
      vicinity: self.vicinity,
      lessonType: self.lessonType,
    };
  }
  function updateFields(_data: any) {
    const self = { ...data };
    setData({ ...self, ..._data });
  }
  async function onSubmitForm(_data: any) {
    try {
      setLoading(true);
      const result = { ...data, ..._data };
      delete result["regions"];
      delete result["countries"];
      const loadingState = await adapter.onSubmit("lesson-location", result);
      if (loadingState) {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      throw error;
    }
  }
  return {
    clientLessonType: Array.isArray(data.lessonType)
      ? data.lessonType[0]
      : data.lessonType,
    supportedCountries: data.countriesSupported?.map((o) => o.name) || [],
    countryCode: data.country_code,
    inSupportedCountry,
    landingProps: {
      firstName: "",
      title: "",
      email: "",
      customerType: data.customerType || "parent",
      country: data.country,
      phone: data.phone,
      country_code: data.country_code,
    },
    onSubmitForm,
    loading,
    stateOptions: getStates,
    regionOptions: getRegions,
    countryOptions: data.countries?.map((item) => item.name) || [],
    getCountryCode,
    factor: getFactor(),
    lessonTypeOptions: ["physical", "online"],
    handleChange,
    state: data.state,
    region: data.region,
    country: data.country,
    lessonType: data.lessonType,
    regions: data.regions || [],
    countries: data.countries || [],
    asJSON: {
      state: data.state || "",
      region: data.region || "",
      country: data.country || "",
      lessonType: data.lessonType || "",
      address: data.address || "",
      vicinity: data.vicinity || "",
    },
    placeholder: placeholder(),
    formatOptions,
    updateFields,
  };
};

export type IReturnUseLocationVM = ReturnType<typeof useLocationVM>;
